webpackJsonp([33],{

/***/ 1078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_holding_cus_vue__ = __webpack_require__(1190);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_179bd420_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_holding_cus_vue__ = __webpack_require__(1315);
function injectStyle (ssrContext) {
  __webpack_require__(1313)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-179bd420"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_holding_cus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_179bd420_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_holding_cus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);



// axios.defaults.timeout = 3000
// var TimeoutReq = {timeout: 60 * 5 * 1000}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseIncome: function expenseIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/income', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dailyReport: function dailyReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/send/shift', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/tran/item/section', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByCus: function holdingByCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByPaybill: function holdingByPaybill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/paybill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByRemain: function holdingByRemain(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleType: function saleType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDocType: function saleDocType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/sale/doctype/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleByItem: function saleByItem(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/group/begin', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportSaleCustomer: function reportSaleCustomer(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportHoldbillInvoice: function reportHoldbillInvoice(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/invoice', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardReport: function StandardReport(URL, header, body, success, error) {
    console.log(body);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/v2/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardCostReport: function StandardCostReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/item/cost/standard', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  addSale: function addSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateSale: function UpdateSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdBill: function holdBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/holdbill', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openShift: function openShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/open', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  closeShift: function closeShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/close', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShiftDetail: function getHostShiftDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/details', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billList: function billList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBill: function printBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/cash/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printHolding: function printHolding(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/hold/slip', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBillCredit: function printBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/credit/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPaybill: function printPaybill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSaleOnHost: function getSaleOnHost(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/cancel', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHoldingBill: function getHoldingBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/holdbill/list', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/bill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getReportBill: function getReportBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  ExportMoney: function ExportMoney(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/expense/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  PrintCloseShif: function PrintCloseShif(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/shift/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openCashBox: function openCashBox(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/open/cashbox', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveList: function receiveList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveCancel: function receiveCancel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveById: function receiveById(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditList: function billCreditList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/bill/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveNew: function receiveNew(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveUpdate: function receiveUpdate(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptSearch: function receiptSearch(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDetail: function receiptDetail(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDel: function receiptDel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  payBillCredit: function payBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPayBillCredit: function printPayBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosByDoc: function getPosByDoc(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosList: function getPosList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/return/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditDetail: function billCreditDetail(URL, header, body, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/print/data', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/print/data', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billReceiptDetail: function billReceiptDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipExpend: function slipExpend(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/expense/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipIncome: function slipIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/income/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkReturn: function checkReturn(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/check/return', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_pos__ = __webpack_require__(1105);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      report_data: [],
      startDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      endDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      host_list: [],
      host: null
    };
  },

  methods: {
    getReport: function getReport() {
      var _this = this;

      var branch = 0;
      this.report_data = [];
      this.form_data = '';
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        company_id: 1,
        host_code: this.host.host_code,
        branch_id: 1
      };
      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].holdingByCus(sessionStorage.Url, this.header, obj, function (result) {
        _this.$store.state.isLoading = false;
        if (result.response === 'success') {
          _this.report_data = result.data;
          console.log(_this.report_data);
          _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.report_data);
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.state.isLoading = false;
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    getHost: function getHost() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_service_pos__["a" /* default */].getHostShift(sessionStorage.Url, this.header, function (result) {
        if (result.response === 'success') {
          _this2.host_list = result.data;
          _this2.host = _this2.host_list[0];
          // this.getReport()
        } else {
          _this2.$notification['warning']({
            message: 'ดึงข้อมูลจุดขายไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    calQTY: function calQTY(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v['qty'];
      });
      return total;
    },
    calAmount: function calAmount(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v['amount'];
      });
      return total;
    },
    calAmountBranch: function calAmountBranch(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v['total_amount'];
      });
      return total;
    },
    calAmountBranchAll: function calAmountBranchAll(obj) {
      var total = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          total += val['total_amount'];
        });
      });
      return total;
    }
  },
  mounted: function mounted() {
    this.checkUser();
    this.getHost();
    this.getBranch();
  }
});

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1314);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("70294c5a", content, true, {});

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".head_table[data-v-179bd420]{background-color:#ffffad}.head-branch[data-v-179bd420]{font-size:18px;color:#000;font-weight:700}.table .thead-dark th[data-v-179bd420]{color:#000;background-color:#ffffad;border-color:#ffffad}.table .thead-footer th[data-v-179bd420]{color:#000;text-align:center;background-color:#ffff}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/report_holding_cus.vue"],"names":[],"mappings":"AACA,6BACE,wBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,WAAoB,AACpB,eAAkB,CACnB,AACD,uCACE,WAAe,AACf,yBAA0B,AAC1B,oBAAsB,CACvB,AACD,yCACE,WAAe,AACf,kBAAmB,AACnB,sBAAwB,CACzB","file":"report_holding_cus.vue","sourcesContent":["\n.head_table[data-v-179bd420] {\n  background-color: #ffffad;\n}\n.head-branch[data-v-179bd420] {\n  font-size: 18px;\n  color: rgb(0, 0, 0);\n  font-weight: bold;\n}\n.table .thead-dark th[data-v-179bd420] {\n  color: #000000;\n  background-color: #ffffad;\n  border-color: #ffffad;\n}\n.table .thead-footer th[data-v-179bd420] {\n  color: #000000;\n  text-align: center;\n  background-color: #ffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card card-solid",style:({ 'min-height': _vm.$store.state.screenHeight - 200 + 'px' })},[_c('div',{staticClass:"card-header pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกสาขา")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.branch),expression:"branch"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.branch=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกสาขา --")]),_vm._v(" "),_vm._l((_vm.$store.state.branch_list),function(b,i){return _c('option',{key:'branch' + i,domProps:{"value":b}},[_vm._v(_vm._s(b.branch_name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกจุดขาย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.host),expression:"host"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.host=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกจุดขาย --")]),_vm._v(" "),_vm._l((_vm.host_list),function(h,i){return _c('option',{key:'host' + i,domProps:{"value":h}},[_vm._v(_vm._s(h.host_name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("จากวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("ถึงวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_holding_cus.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.calAmountBranchAll(_vm.report_data) < 1}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_holding_cus.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.calAmountBranchAll(_vm.report_data) < 1}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n            ")])])])]),_vm._v(" "),(_vm.report_data.length < 1)?_c('div',{staticClass:"text-center pt-3"},[_c('h5',[_vm._v("ไม่มีข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.report_data),function(c,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(c.length > 0),expression:"c.length > 0"}],key:'c' + i,staticClass:"table-responsive-sm mt-3"},[_c('h4',{staticClass:"m-1 p-1"},[_vm._v("\n          สาขา: "+_vm._s((c[0])? c[0]['branch_name'] || '-' : '-')+"\n               จุดขาย: "+_vm._s((c[0])? c[0]['host_code'] || '-' : '-')+"\n        ")]),_vm._v(" "),_vm._l((c),function(c,i){return _c('table',{key:'c' + i,staticClass:"table table-bordered",attrs:{"id":"sendMoney"}},[_c('tbody',[_c('tr',{staticStyle:{"background":"#fffed4"}},[_c('th',{attrs:{"colspan":"6"}},[_vm._v("ลูกค้า: "+_vm._s(c.ar_name))])]),_vm._v(" "),_c('tr',{staticStyle:{"background":"#fffed4"}},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("เลขที่ใบพักบิล: "+_vm._s(c.doc_no))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("วันที่: "+_vm._s(_vm.dateFormatAndTime(c.doc_date)))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("ส่วนลด: "+_vm._s(_vm.numberFormatDecimal(c.discount_amount)))])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._l((c.sub),function(s,i){return _c('tr',{key:'csub' + i},[_c('td',[_vm._v(_vm._s(s.item_barcode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(s.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(s.normal_price)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(s.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(s.amount)))])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"6"}},[_vm._v("### รวมรายการ: "+_vm._s(c.sub.length)+" ###")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Remark: "+_vm._s(c.description || '-'))]),_vm._v(" "),_c('td',{staticStyle:{"background":"#ebf6ff"}},[_vm._v("รวมพักบิล: "+_vm._s(c.doc_no))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.calQTY(c.sub))))]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"background":"#ffd5d4"}},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"background":"#e2ffd4"}},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.calAmount(c.sub))))])])],2)])}),_vm._v(" "),_c('h5',[_vm._v("รวมสาขา: "+_vm._s((c[0])? c[0]['branch_name'] || '-' : '-')+": "+_vm._s(_vm.numberFormatDecimal(_vm.calAmountBranch(c)))+" บาท")])],2)}),_vm._v(" "),(_vm.calAmountBranchAll(_vm.report_data) > 0)?_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('th',{staticClass:"pt-2 pl-2 pb-0",staticStyle:{"background":"#eeffeb","text-align":"left"}},[_c('h5',[_vm._v("รวมทุกสาขา: "+_vm._s(_vm.numberFormatDecimal(_vm.calAmountBranchAll(_vm.report_data)))+" บาท")])])])]):_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"text-center",staticStyle:{"background":"#ebf6ff"}},[_c('th',[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('th',[_vm._v("รายละอียด")]),_vm._v(" "),_c('th',[_vm._v("ราคาต่อหน่วย")]),_vm._v(" "),_c('th',[_vm._v("จำนวน")]),_vm._v(" "),_c('th',[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',[_vm._v("รวม")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/33.31797ddaaecee41e6c43.js